module.exports = __webpack_public_path__ + "static/media/ic-office.265ee25b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/ic-office.svg
// module id = 439
// module chunks = 0